export default "<div class=\"cursor-pointer\" (click)=\"onClickIcon()\">\r\n    <i [class]=\"iconClassName\"></i>\r\n</div>\r\n";